/**
 * Accessible Swiper pagination: ul > li > button.
 * The nested button is the only interactive control (click, Space, Enter).
 */

export function renderPaginationBullet(index, className) {
    return `<li class="${className}">
        <button type="button" class="swiper-pagination-bullet-button">
            <span class="sr-only">Go to slide ${index + 1}</span>
        </button>
    </li>`;
}

export const accessiblePagination = {
    clickable: true,
    bulletElement: 'li',
    renderBullet: renderPaginationBullet,
};

/**
 * Make each pagination button the slide trigger and keep the li inert.
 * Call from Swiper on.init / on.paginationUpdate (and after slideChange if needed).
 */
export function bindPaginationButtons(swiper) {
    const paginationEl = swiper.pagination?.el;
    if (!paginationEl) {
        return;
    }

    const bullets = paginationEl.querySelectorAll('.swiper-pagination-bullet');
    bullets.forEach((bullet, index) => {
        bullet.removeAttribute('tabindex');
        bullet.removeAttribute('role');
        bullet.removeAttribute('aria-label');
        bullet.removeAttribute('aria-current');

        const button = bullet.querySelector('button');
        if (!button) {
            return;
        }

        button.type = 'button';
        button.setAttribute('aria-label', `Go to slide ${index + 1}`);
        button.setAttribute('aria-current', bullet.classList.contains('swiper-pagination-bullet-active') ? 'true' : 'false');

        if (button.dataset.bound === 'true') {
            return;
        }

        button.dataset.bound = 'true';
        button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            if (swiper.params.loop) {
                swiper.slideToLoop(index);
            } else {
                swiper.slideTo(index);
            }
        });
    });
}
